import { ReactElement } from "react";
import { EgnyteGlobalSearchResultItem, GlobalSearchScopeIdentifier } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { TimeZone } from "client/DateAndTime/timezones";
import { EgnyteListItem } from "../../../Items/EgnyteListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { generateTrackingId } from "client/Misc/utils";
import { useEgnyteNavigationHandler } from "../../../Navigation/useEgnyteNavigationHandler";

export type EgnyteItemViewProps = {
	item: EgnyteGlobalSearchResultItem;
	itemIndex: number;
	itemScope: GlobalSearchScopeIdentifier;
	onDismiss?(): void;
	isMobile: boolean;
	timezone: TimeZone;
	tabIndex: number;
};

export const EgnyteItemView = (props: EgnyteItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		itemScope,
		onDismiss,
		isMobile,
		timezone,
		tabIndex
	} = props;

	const {
		extension,
		name,
		path,
		url,
		lastModifiedDate,
		modifiedBy,
		locationUrl,
		hitHighlights
	} = item;

	const openHandler: () => void = useEgnyteNavigationHandler({
		url,
		searchResult: item,
		itemScope
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("egnyte-item", `|${url}`)}
			onClick={openHandler}
		>
			<EgnyteListItem
				isMobile={isMobile}
				hitHighlights={hitHighlights}
				extension={extension}
				name={name}
				path={path}
				url={url}
				lastModifiedDate={lastModifiedDate}
				modifiedBy={modifiedBy}
				locationUrl={locationUrl}
				onDismiss={onDismiss}
				timezone={timezone}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};

EgnyteItemView.displayName = "EgnyteItemView";
